import React, { useEffect, useState, useContext, useRef } from 'react'
import './searchItems.css'
import Slider from 'react-slick'
import { addSlashes } from '../../../utils/commonFunctions'
import ProductContext from '../../../Product/context/product/productContext'
import AuthContext from '../../../Product/context/auth/authContext'
import CancelOutlinedIcon from '@material-ui/icons/CancelOutlined'
import AlertContext from '../../../Product/context/alert/alertContext'
import NoRecordsFound from '../../../Product/components/atoms/NoRecordsFound'
import SearchProductList from '../../../Component/ProductCard/lotListProduct'
import Layout from '../Layout'
import { useFormik } from 'formik'
import FilterPanel from '../../../Product/components/organisms/FilterPanel'
import Loaders from '../../../Product/components/molecules/Loaders'
import { Button, Chip, Drawer, Paper, useMediaQuery } from '@material-ui/core'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/core/styles'
import { useLocation, useParams } from 'react-router-dom'
import { Pagination } from '@material-ui/lab'
import { messageHandler } from '../../../Product/common/socketHandler'
import { socket, socketAuction } from '../../../Product/common/socket'
import CustomSelect from '../../../Product/components/atoms/Inputs/CustomSelect'
import UserActivity from '../../../utils/CommonFunctionality/UserActivity'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import Reviews from '../Home/review'
import LotProduct from '../../../Component/ProductCard/lotProduct'
import moment from 'moment'
import SEOTAG from '../../../utils/CommonFunctionality/SEO/AllpagesSEO'
import { handleRedirectInternal } from '../../../Product/common/components'
const useStyles = makeStyles((theme) => ({
    fullList: {
        width: 'auto',
    },
    root: {
        display: 'flex',
        justifyContent: 'flex-start',
        flexWrap: 'wrap',
        listStyle: 'none',
        boxShadow: 'none',
        padding: theme.spacing(0),
        margin: 0,
    },
    chip: {
        margin: theme.spacing(0.5),
        marginBottom: '15px',
    },
}))

const AuctionSearchComponent = (props) => {
    const location = useLocation()
    const { cat_title } = useParams()
    const productContext = useContext(ProductContext)
    const authContext = useContext(AuthContext)
    const alertContext = useContext(AlertContext)
    const history = useHistory()
    const [state, setState] = useState({
        right: false,
        bottom: false,
        data: {},
    })
    const {
        search_allproducts,
        getAllSearchProducts,
        productLocalState,
        get_all_cat,
        getAllSearchItems,
        getAllSearchAuctions,
        search_allauctions,
    } = productContext
    const { setAlert } = alertContext
    const { user } = authContext
    const classes = useStyles()
    const [isLoading, setLoading] = useState(true)
    const [viewProduct, setViewProduct] = useState([])
    const [filterData, setFilterData] = useState([])
    const [suggestedProducts, setSuggestedProducts] = useState([])
    const [recentlyViewedProducts, setRecentlyViewedProducts] = useState([])
    const [searchbarValue, setSearchValue] = useState('')
    const [auctionList, setAuctionList] = useState([])
    const [pickupDetails, setPickupDetails] = useState()

    const [totalViewProduct, setTotalViewProduct] = useState(0)
    const [auctionView, setAuctionView] = useState('grid')
    const isBuyBestProject = global.storeConfigration?.bodyClass2?.value === 'buyBestProject'
    const [audio] = useState(
        global.storeConfigration?.bidding_sound?.value == 1 ? new Audio('/audio/ding.mp3') : '',
    )
    const isBargainsProject = global.storeConfigration?.bodyClass2?.value === 'bargainsClass'

    const [chipData, setChipData] = React.useState([])
    const [states, setStates] = useState([])
    const [searchCategories, setSearchCategories] = useState([])
    const [searchCategories2, setSearchCategories2] = useState([])
    const [size, setSize] = useState([])
    const params = new URLSearchParams(location.search)
    const [page, setPage] = useState(isBuyBestProject ? params.get('page') ?? 1 : 1)
    const [cat_name, setCatName] = useState(null)
    const [cat_val, setCatVal] = useState([])
    const [catg, setCatg] = useState(
        new URLSearchParams(window.location.search.substring(1)).get('cat'),
    )
    const [rat] = useState(new URLSearchParams(window.location.search.substring(1)).get('rat'))
    const [est] = useState(new URLSearchParams(window.location.search.substring(1)).get('est') || 0)
    const [view] = useState(new URLSearchParams(window.location.search.substring(1)).get('view'))
    const isVarifiedGfTheme = global.storeConfigration?.bodyClass?.value === 'greenField'
    const isMobile = useMediaQuery('(max-width:600px)')
    const [catList, setCatList] = useState([])
    const [eventList, setEventList] = useState([])
    const [min_price_val, setMin_price_val] = useState(null)
    const [max_price_val, setMax_price_val] = useState(null)
    const [conditionList, setConditionList] = useState([])
    const [resetFilter, setResetFilter] = useState(false)
    const [sort, setSortValue] = useState(
        new URLSearchParams(window.location.search.substring(1)).get('sort') ||
            (location.pathname.includes('/todays-top-deals')
                ? '1'
                : location.pathname.includes('/recently-listed')
                ? '2'
                : location.pathname.includes('/deals-ending-soon')
                ? '7'
                : location.pathname.includes('/buynow')
                ? '01'
                : cat_title
                ? isVarifiedGfTheme
                    ? '17'
                    : '6'
                : ''),
    )
    const [slimit] = useState(
        new URLSearchParams(window.location.search.substring(1)).get('slimit') || 50,
    )

    let lotof = new URLSearchParams(window.location.search.substring(1)).get('lotof')
    let isAuction = new URLSearchParams(window.location.search.substring(1)).get('auction')

    const [auctionTitle, setAuctionTitle] = useState(
        new URLSearchParams(window.location.search.substring(1)).get('title') ||
            (location.pathname.includes('/todays-top-deals')
                ? 'Todays Top Deals'
                : location.pathname.includes('/recently-listed')
                ? 'Recently Listed'
                : location.pathname.includes('/deals-ending-soon')
                ? 'Deals Ending Soon'
                : location.pathname.includes('/buynow')
                ? 'Buy Now'
                : null),
    )

    const [handleLocations, setHandleLocations] = useState()
    //TO show static pick up date text for buy best 4 less proj only
    const pickupDateStaticEnabled =
        global.storeConfigration?.enable_pickup_date_text_static?.value ?? 0
    const pickupDateStaticText = global.storeConfigration?.pickup_date_text_static?.value ?? ''
    useEffect(() => {
        setHandleLocations(productLocalState.globalLocation)
    }, [productLocalState.globalLocation])
    const [suggestedItemSearch, SetSuggestedItemSearch] = useState({
        orderby: sort != '' ? sort : '',
        category: catg == 1 || catg == 0 ? [] : [catg],
        subcategory: [],
        closed_auction_list: 0,
        perlimit: isVarifiedGfTheme ? 4 : slimit !== '' ? slimit : 50,
        no_pagination: isVarifiedGfTheme ? 1 : 0,
        page: 1,
        joinsdata: `a.title as auctionTitle, p.title,a.state as auction_state, a.city as auction_city,a.address as auction_address, a.zipcode as auction_zipcode, p.lot_number,p.sku,p.deed_document,p.lotof,p.auctionnotes,p.avatar as avatar_vc,p.content_head1,p.store_id,p.retailer_link,p.conditionunique,p.hasshipping,p.user_id,p.category_id${
            user?.id ? ',IFNULL(w.id,0) as watchlisted' : ''
        }`,
        nobids: isVarifiedGfTheme ? 1 : 1,
        latestbid: isVarifiedGfTheme ? 0 : 1,
        latestbid_user: 1,
        userid: user?.id,
        getbidding: isVarifiedGfTheme ? 0 : 1,
        need_bid_increment: isVarifiedGfTheme ? 0 : 1,
        need_pickup_details: isBuyBestProject ? 1 : 0,
        lot_images: isBuyBestProject ? 1 : 0,
        order_by: ' order by p.most_viewed DESC',
        customwhere: 'p.market_status="open" and p.qty > 0 ',
        joins: user?.id
            ? `left join watchlists as w on w.project_id=p.id and w.user_id = ${user?.id} and w.is_delete = 0 inner join auctionlot as a on a.id=p.lotof `
            : ` inner join auctionlot as a on a.id=p.lotof `,

        location: [],
        from: 'auction_only',
        from_id: 1,
        auction_io: 1,
        auction_city:
            productLocalState.globalLocation != 'All' ? [productLocalState.globalLocation] : [],
        size: [],
        get_city_state: 1,
        dont_show: global?.storeConfigration?.donot_show_categories?.value
            ? global.storeConfigration?.donot_show_categories?.value?.split(',')
            : [],
    })

    const [recentlyViewedSearch, SetRecentlyViewedSearch] = useState({
        closed_auction_list: 0,
        perlimit: isVarifiedGfTheme ? 10 : slimit !== '' ? slimit : 50,
        no_pagination: isVarifiedGfTheme ? 1 : 0,
        from: 'auction_only',
        from_id: 1,
        auction_io: 1,
        auction_city:
            productLocalState.globalLocation != 'All' ? [productLocalState.globalLocation] : [],
        joinsdata: isVarifiedGfTheme
            ? 'p.avatar as avatar_vc'
            : 'a.title as auctionTitle, p.title,a.state as auction_state, a.city as auction_city,a.address as auction_address, a.zipcode as auction_zipcode,p.lot_number,p.sku,p.deed_document,p.lotof,p.auctionnotes,p.avatar as avatar_vc,p.content_head1,p.store_id,p.retailer_link,p.conditionunique,p.hasshipping,p.user_id,p.category_id',
        size: [],
        get_city_state: 1,
        joins: ' inner join auctionlot as a on a.id=p.lotof ',
    })

    const mountedRef = useRef()
    const previousState = useRef()

    const getOrderBy = (orderby) => {
        let order = ' order by '

        if (orderby == '') {
            order += 'p.date_closed asc'
        }
        if (orderby == 1) {
            order += 'p.most_viewed DESC'
        }
        if (orderby == 7) {
            order += 'p.date_closed asc'
        }
        if (orderby == 3) {
            order += 'IF (p.auction = 1, p.wprice,p.bprice) asc'
        }
        if (orderby == 11) {
            order += 'IF (p.auction = 1, p.wprice,p.bprice) desc'
        }
        if (orderby == 6) {
            order += 'p.date_closed asc'
        }
        if (orderby == 2) {
            order += 'p.id desc'
        }
        if (orderby == 14) {
            if (global?.storeConfigration?.lot_sequence_order?.value == 1)
                order += 'CAST(p.lot_number AS UNSIGNED) ASC'
            else order += 'CAST(p.sku AS UNSIGNED) ASC'
        }
        if (orderby == 15) {
            if (global?.storeConfigration?.lot_sequence_order?.value == 1)
                order += 'CAST(p.lot_number AS UNSIGNED) DESC'
            else order += 'CAST(p.sku AS UNSIGNED) DESC'
        }
        if (
            global?.storeConfigration?.lot_sequence_order?.value == 1 &&
            orderby != 14 &&
            orderby != 15
        ) {
            order += ',CAST(p.lot_number AS UNSIGNED) ASC '
        }
        if (orderby == 16) {
            order += 'p.wprice asc, p.bprice asc'
        }
        if (orderby == 17) {
            order += 'p.wprice desc, p.bprice desc'
        }
        if (orderby == 18) {
            order += 'p.mprice asc'
        }
        if (orderby == 19) {
            order += 'p.mprice desc'
        }

        return order
    }

    const getSearchBar = (searchbar) => {
        let where = ''
        if (searchbar) {
            const searchValue = searchbar.trim()
            if (
                global.storeConfigration?.show_warehouse_location?.value == 1 &&
                global.storeConfigration?.lot_sequence_order?.value == 1
            ) {
                where +=
                    ' and (p.title like "%' +
                    addSlashes(searchValue) +
                    '%" or p.tags like "%' +
                    addSlashes(searchValue) +
                    '%" or p.description like "%' +
                    addSlashes(searchValue) +
                    '%" or p.location like "%' +
                    addSlashes(searchValue) +
                    '%" or p.lot_number like "%' +
                    addSlashes(searchValue) +
                    '")'
            } else if (global.storeConfigration?.lot_sequence_order?.value == 1) {
                where +=
                    ' and (p.title like "%' +
                    addSlashes(searchValue) +
                    '%" or p.tags like "%' +
                    addSlashes(searchValue) +
                    '%" or p.lot_number like "%' +
                    addSlashes(searchValue) +
                    '")'
            } else if (global.storeConfigration?.show_warehouse_location?.value == 1) {
                where +=
                    ' and (p.title like "%' +
                    addSlashes(searchValue) +
                    '%" or p.tags like "%' +
                    addSlashes(searchValue) +
                    '%" or p.description like "%' +
                    addSlashes(searchValue) +
                    '%" or p.location like "%' +
                    addSlashes(searchValue) +
                    '")'
            } else {
                where +=
                    ' and (p.title like "%' +
                    addSlashes(searchValue) +
                    '%" or p.tags like "%' +
                    addSlashes(searchValue) +
                    '%" or p.description like "%' +
                    addSlashes(searchValue) +
                    '%" or p.lot_number like "%' +
                    addSlashes(searchValue) +
                    '")'
            }
        }
        return where
    }
    const getWhere = (type, keys, orderby) => {
        let where = 'p.market_status="open" and p.qty > 0 '

        where +=
            orderby == 7 ? ' and auction=1' : orderby == '01' ? ' and buynow=1 and auction=0' : ''
        if (type === 'search') {
            where += getSearchBar(keys)
        }
        if (type === 'location') {
            where += keys
        }
        return where
    }
    const formik = useFormik({
        initialValues: {
            orderby: sort != '' ? sort : '',
            category: catg == 1 || catg == 0 ? [] : [catg],
            subcategory: [],
            closed_auction_list: 0,
            perlimit: slimit !== '' ? slimit : 50,
            page: isBuyBestProject ? params.get('page') ?? 1 : 1,
            joinsdata: `a.title as auctionTitle, p.title,a.state as auction_state, a.city as auction_city,a.address as auction_address, a.zipcode as auction_zipcode,p.lot_number,p.sku,p.deed_document,p.lotof,p.auctionnotes,p.avatar as avatar_vc,p.content_head1,p.store_id,p.retailer_link,p.conditionunique,p.hasshipping,p.user_id,p.category_id${
                user?.id ? ',IFNULL(w.id,0) as watchlisted' : ''
            }`,
            nobids: isVarifiedGfTheme ? 1 : 1,
            latestbid: isVarifiedGfTheme ? 0 : 1,
            latestbid_user: 1,
            userid: user?.id,
            getbidding: isVarifiedGfTheme ? 0 : 1,
            need_bid_increment: isVarifiedGfTheme ? 0 : 1,
            need_pickup_details: isBuyBestProject ? 1 : 0,
            lot_images: isBuyBestProject ? 1 : 0,
            delivery: [],
            order_by: getOrderBy(sort != '' ? sort : ''),
            customwhere:
                params.get('q') !== ''
                    ? getWhere('search', params.get('q'))
                    : getWhere('search', ''),
            joins: user?.id
                ? `left join watchlists as w on w.project_id=p.id and w.user_id = ${user?.id} and w.is_delete = 0 inner join auctionlot as a on a.id=p.lotof `
                : ` inner join auctionlot as a on a.id=p.lotof `,

            location: [],

            toprice: est !== '' ? est : 0,
            quality_rating: rat == null || rat == 1 || rat == '' ? [] : rat,
            from: 'auction_only',
            from_id: 1,
            auction_io: 1,

            auction_city:
                productLocalState.globalLocation != 'All' ? [productLocalState.globalLocation] : [],
            size: [],
            get_city_state: 1,
            dont_show: global?.storeConfigration?.donot_show_categories?.value
                ? global.storeConfigration?.donot_show_categories?.value?.split(',')
                : [],
            special_events: lotof ? [lotof] : [],
            mprice_filter: [],
            rating_multiple_io: [],
        },
    })

    useEffect(() => {
        setLoading(true)
        formik.setFieldValue(
            'auction_city',
            productLocalState.globalLocation == 'All' ? [] : [productLocalState.globalLocation],
        )
        let globalLoc =
            productLocalState.globalLocation == 'All'
                ? ''
                : ` and a.city="${productLocalState.globalLocation}"`
        getWhere('location', globalLoc)
    }, [productLocalState.globalLocation])

    useEffect(() => {
        if (global?.searchCategories) {
            setSearchCategories2(
                global.searchCategories.sort((a, b) => a.name.localeCompare(b.name)),
            )
        }
    }, [global?.searchCategories])

    useEffect(() => {
        if (!isVarifiedGfTheme || !user?.id) {
            getAllSearchItems(
                {
                    ...suggestedItemSearch,
                },
                'suggestedItems',
            )
        }
    }, [suggestedItemSearch])

    useEffect(() => {
        if (global.storeConfigration?.enable_recently_viewed?.value == 1) {
            let items = JSON.parse(localStorage.getItem('recentlyViewed')) || []
            let whereCondition = `p.market_status="open" and p.qty > 0 `
            if (items.length >= 1) {
                whereCondition += ` and p.id in (${items.join(',')})`
            }

            getAllSearchItems(
                {
                    ...recentlyViewedSearch,

                    customwhere: whereCondition,
                },
                'recentlyViewedItems',
            )
        }
    }, [recentlyViewedSearch])

    useEffect(() => {
        getAllSearchAuctions(
            {
                auc_type: 13,
                auction_only: 1,
                orderby: '2',
                page: 1,
                searchbar: '',
                sh_limit: '10',
                type: '',
                is_retail: isVarifiedGfTheme ? 1 : undefined,
            },
            'searchPage',
        )
        localStorage.setItem('routeTo', '')
    }, [])

    useEffect(() => {
        if (search_allauctions.from === 'searchPage') {
            setAuctionList(search_allauctions.results.length ? search_allauctions.results : [])
        }
    }, [search_allauctions])

    useEffect(() => {
        let sortChange =
            new URLSearchParams(location.search).get('sort') ||
            (location.pathname.includes('/todays-top-deals')
                ? '1'
                : location.pathname.includes('/recently-listed')
                ? '2'
                : location.pathname.includes('/deals-ending-soon')
                ? '7'
                : location.pathname.includes('/buynow')
                ? '01'
                : cat_title
                ? '6'
                : '')

        formik.setFieldValue('order_by', getOrderBy(sortChange !== '' ? sortChange : ''))
    }, [location.search, cat_title])

    const estimated_arr = [
        { id: 0, description: 'Any', value: [0] },
        { id: 1, description: 'Under $20', value: [0, 20] },
        { id: 2, description: '$20-$50', value: [20, 50] },
        { id: 3, description: '$50-$100', value: [50, 100] },
        { id: 4, description: '$100-$500', value: [100, 500] },
        { id: 5, description: 'Above $500', value: [500] },
    ]

    const delivery_options = [
        {
            value: '1',
            id: '1',
            show: 'Local Pickup',
            description: 'Local Pickup',
        },
        {
            value: '2',
            id: '2',
            show: 'Shipping',
            description: 'Shipping',
        },
    ]

    const special_event_options =
        search_allauctions?.results?.length > 0
            ? search_allauctions?.results
                  .sort((a, b) => new Date(a.date_closed) - new Date(b.date_closed))
                  .map((val) => {
                      return {
                          description: moment(val.date_closed).format('dddd, MMMM DD'),
                          id: val.id,
                      }
                  })
            : []

    if (global?.storeConfigration?.need_buynow_search?.value == 1) {
        var filterValues = [
            {
                title: 'View',
                type: 'radio',
                noLabel: true,
                name: 'closed_auction_list',
                int: 1,
                class: 'col-12',
                item: [
                    { id: 0, description: 'Live Items' },
                    { id: 1, description: 'Closed Items' },
                ],
                formik: formik,
            },
            {
                title: 'Type',
                type: 'radio',
                noLabel: true,
                name: 'from_id',
                int: 1,
                class: 'col-12',
                item: [
                    { id: 0, description: 'All' },
                    { id: 1, description: 'Auction' },
                    { id: 2, description: 'Buy Now' },
                ],
                formik: formik,
            },
            {
                title: 'Category',
                type: 'check',
                name: 'category',
                int: 1,
                noLabel: true,
                options: global.searchCategories.filter((main) => {
                    return true
                }),
                formik: formik,
            },
            {
                title: 'Sub category',
                type: 'check',
                name: 'subcategory',
                options: global.searchSubCategories.filter((subcat) => {
                    // if (
                    //     formik &&
                    //     formik.values &&
                    //     formik.values.category &&
                    //     formik.values.category.length
                    //         ? formik.values.category.includes(subcat.level_id.toString())
                    //         : false
                    // ) {
                    return true
                    //}
                }),
                formik: formik,
            },
        ]
    } else {
        const allowedCategoryIds = catList || []
        const allowedConditions = conditionList || []
        const min_price = min_price_val
        const max_price = max_price_val
        const filteredEstimates =
            min_price == null && max_price == null
                ? []
                : estimated_arr.filter((item) => {
                      const [min, max] = item.value

                      if (item.id === 0) return true

                      if (item.id === 5) return min_price >= min || max_price >= min

                      return (
                          (min >= min_price && min <= max_price) ||
                          (max >= min_price && max <= max_price) ||
                          (min <= min_price && max >= max_price)
                      )
                  })

        const allowedEvents = eventList
        // auctionTitle !== 'Flash Deals' &&
        // auctionTitle !== 'Todays Top Deals' &&
        // auctionTitle !== 'Recently Listed' &&
        // auctionTitle !== 'Deals Ending Soon' &&
        // auctionTitle !== 'Buy Now' &&
        // cat_name == null
        //     ? []
        //     : filterData?.[0]?.lotof_new || []
        var filterValues = [
            {
                title: 'Auction Close Date',
                type: 'check',
                noLabel: true,
                name: 'special_events',
                defaultOpen: isMobile ? false : true,
                int: 1,
                // class: 'col-12',
                options:
                    cat_name ||
                    (auctionTitle !== 'Flash Deals' &&
                        auctionTitle !== 'Todays Top Deals' &&
                        auctionTitle !== 'Recently Listed' &&
                        auctionTitle !== 'Deals Ending Soon' &&
                        auctionTitle !== 'Buy Now' &&
                        (searchbarValue == '' || searchbarValue == null) &&
                        isAuction != 1)
                        ? // If cat_name is not null → show all events without filtering
                          search_allauctions?.results?.length
                            ? search_allauctions.results
                                  .sort((a, b) => new Date(a.date_closed) - new Date(b.date_closed))
                                  .map((val) => ({
                                      description: moment(val.date_closed).format('dddd, MMMM DD'),
                                      id: val.id,
                                  }))
                            : []
                        : // If cat_name is null → apply allowedEvents filtering logic
                        allowedEvents.length == 0
                        ? []
                        : search_allauctions?.results?.length
                        ? search_allauctions.results
                              .sort((a, b) => new Date(a.date_closed) - new Date(b.date_closed))
                              .filter((data) =>
                                  allowedEvents.length > 0
                                      ? allowedEvents.includes(String(data.id))
                                      : true,
                              )
                              .map((val) => ({
                                  description: moment(val.date_closed).format('dddd, MMMM DD'),
                                  id: val.id,
                              }))
                        : [],

                formik: formik,
            },
            {
                title: 'Category',
                type: 'check',
                name: 'category',
                noLabel: true,
                defaultOpen: isMobile ? false : true,
                class: 'col-12',
                int: 1,
                options: cat_name
                    ? // if cat_name is not null → show all categories without filtering
                      searchCategories2.map((data) => ({
                          value: data.value,
                          id: data.id,
                          show:
                              global.storeConfigration?.cat_with_count?.value == 1
                                  ? `${data.name} (${data.product_cnt})`
                                  : `${data.name}`,
                          description:
                              global.storeConfigration?.cat_with_count?.value == 1
                                  ? `${data.name} (${data.product_cnt})`
                                  : `${data.name}`,
                      }))
                    : // If cat_name is null → apply existing filtering logic
                    allowedCategoryIds.length > 0
                    ? searchCategories2.length > 0 &&
                      global.storeConfigration?.cat_with_count?.value == 1
                        ? searchCategories2
                              .filter((data) => data?.name?.toLowerCase()?.trim() !== 'adult')
                              .filter((data) =>
                                  (formik.values.special_events.length > 0 ||
                                      allowedConditions.length > 0) &&
                                  allowedCategoryIds.length > 0
                                      ? allowedCategoryIds.includes(String(data.id))
                                      : true,
                              )
                              .map((data) => ({
                                  value: data.value,
                                  id: data.id,
                                  show: `${data.name} (${data.product_cnt})`,
                                  description: `${data.name} (${data.product_cnt})`,
                              }))
                        : searchCategories2
                              .filter((data) => data?.name?.toLowerCase()?.trim() !== 'adult')
                              .filter((data) =>
                                  (formik.values.special_events.length > 0 ||
                                      allowedConditions.length > 0) &&
                                  allowedCategoryIds.length > 0
                                      ? allowedCategoryIds.includes(String(data.id))
                                      : true,
                              )
                              .map((data) => ({
                                  value: data.value,
                                  id: data.id,
                                  show: `${data.name}`,
                                  description: `${data.name}`,
                              }))
                    : [],

                formik: formik,
            },
            {
                title: 'Condition',
                type: 'check',
                noLabel: true,
                name: 'quality_rating',
                int: 1,
                class: 'col-12',
                options:
                    (auctionTitle == 'Flash Deals' ||
                        auctionTitle == 'Todays Top Deals' ||
                        auctionTitle == 'Recently Listed' ||
                        auctionTitle == 'Deals Ending Soon' ||
                        auctionTitle == 'Buy Now' ||
                        cat_name == null) &&
                    allowedConditions.length == 0
                        ? []
                        : global.condition_data
                              .filter((data) =>
                                  // (formik.values.special_events.length > 0 ||
                                  //     formik.values.category.length > 0) &&
                                  allowedConditions.length > 0
                                      ? allowedConditions.includes(String(data.condition))
                                      : true,
                              )
                              .map((item) => {
                                  return {
                                      ...item,
                                      description: item.condition,
                                  }
                              }),
                formik: formik,
            },
            {
                title: 'Estimated Retail',
                type: 'radio',
                noLabel: true,
                name: 'toprice',
                int: 1,
                class: 'col-12',
                priceRange: true,
                item: filteredEstimates,
                formik: formik,
            },
            // {
            //     title: 'Delivery Type',
            //     type: 'check',
            //     name: 'delivery',
            //     noLabel: true,
            //     class: 'col-12 d-block',
            //     options: delivery_options,
            //     formik: formik,
            // },

            {
                title: 'Size',
                type: 'check',
                name: 'size',
                noLabel: true,
                // int: 1,
                class: `${size?.length ? 'col-12 d-block' : 'd-none'}`,
                options:
                    searchCategories2.length > 0 &&
                    size?.map((data) => {
                        // if (formik.values.category.includes(data.category_id))
                        return {
                            value: data.size,
                            id: data.size,
                            show: `${data.size} (${data.product_cnt})`,
                            description: `${data.size} (${data.product_cnt})`,
                        }
                    }),

                // parentcategories.map((data) => {
                //     return {
                //         value: `${data.cat_id}`,
                //         show: data.cat_name,
                //         className: data.cat_id == catClass ? 'active' : '',
                //         description: `${data.cat_name} (${data.catcount})`,
                //         onChange: (e) => {
                //             return handleCat(e)
                //         },
                //     }
                // }),
                formik: formik,
            },
            // {
            //     title: 'Sub category',
            //     type: 'check',
            //     name: 'subcategory',
            // options: global.searchSubCategories.filter((subcat) => {
            // if (
            //     formik &&
            //     formik.values &&
            //     formik.values.category &&
            //     formik.values.category.length
            //         ? formik.values.category.includes(subcat.level_id.toString())
            //         : false
            // ) {
            //         return true
            //         //}
            //     }),
            //     formik: formik,
            // },

            {
                title: 'Adult',
                type: 'check',
                name: 'category',
                noLabel: true,
                class: searchCategories2?.find((val) => val?.name?.toLowerCase()?.trim() == 'adult')
                    ? 'col-12'
                    : 'd-none',
                int: 1,
                options: searchCategories2?.find(
                    (val) => val?.name?.toLowerCase()?.trim() == 'adult',
                )
                    ? searchCategories2
                          .filter((data) => data?.name?.toLowerCase()?.trim() == 'adult')
                          .map((data) => ({
                              value: data.value,
                              id: data.id,
                              show: `${data.name} (${data.product_cnt})`,
                              description: `${data.name} (${data.product_cnt})`,
                          }))
                    : [],
                formik: formik,
            },
        ]
    }
    useEffect(() => {
        if (search_allproducts.from === 'searchPage') {
            setViewProduct(search_allproducts.results.length ? search_allproducts.results : [])
            setPickupDetails(search_allproducts.pick_details?.location)

            setTotalViewProduct(search_allproducts.total_pagecnt)
            const scrollPosition = window.innerWidth <= 768 ? 150 : 400
            window.scrollTo(0, 0)
            setLoading(false)
        }
        if (search_allproducts.from === 'recentlyViewedItems') {
            setRecentlyViewedProducts(
                search_allproducts.results.length ? search_allproducts.results : [],
            )
        }
        if (search_allproducts.from === 'suggestedItems') {
            setSuggestedProducts(
                search_allproducts.results.length ? search_allproducts.results : [],
            )
        }
        if (
            search_allproducts?.categoriesCounts?.length > 0 &&
            searchCategories?.length == 0 &&
            global.storeConfigration?.cat_with_count?.value
        ) {
            var new_cat = global.searchCategories
            new_cat.map((value) => {
                value.catcount =
                    search_allproducts.categoriesCounts.filter(
                        (val) => parseInt(val.category_id) == parseInt(value.id),
                    ).length > 0
                        ? search_allproducts.categoriesCounts.filter(
                              (val) => parseInt(val.category_id) == parseInt(value.id),
                          )[0].CountCat
                        : 0
                if (!value.description.includes(value.catcount)) {
                    value.description = `${value.description + ' '}(${value.catcount})`
                }
            })

            setSearchCategories(new_cat)
        }
        if (search_allproducts.from === 'filterValues') {
            if (
                search_allproducts.results.length > 0 &&
                search_allproducts.results?.[0]?.min_price !== null &&
                search_allproducts.results?.[0]?.max_price !== null &&
                search_allproducts.results?.[0]?.category_ids.length > 0 &&
                (search_allproducts.results?.[0]?.lotof_new.length > 0 ||
                    auctionTitle == 'Buynow') &&
                search_allproducts.results?.[0]?.auctionnotes_new
            ) {
                setFilterData(search_allproducts.results)
                if (search_allproducts.results.length > 0 && formik.values.toprice == 0) {
                    setMin_price_val(search_allproducts.results?.[0]?.min_price || null)
                    setMax_price_val(search_allproducts.results?.[0]?.max_price || null)
                }
                if (
                    search_allproducts.results.length > 0
                    // && formik.values.category.length == 0 &&
                    // formik.values.quality_rating.length == 0 &&
                    // formik.values.toprice == 0
                ) {
                    const categories = search_allproducts.results?.[0]?.rcategory_ids

                    setCatList(categories || [])
                }
                if (
                    search_allproducts.results.length > 0 &&
                    formik.values.quality_rating.length == 0 &&
                    formik.values.toprice == 0
                ) {
                    setConditionList(search_allproducts.results?.[0]?.auctionnotes_new || [])
                }
                if (
                    search_allproducts.results.length > 0 &&
                    (formik.values.special_events.length == 0 || isAuction == 1) &&
                    (formik.values.category.length == 0 || cat_name) &&
                    formik.values.quality_rating.length == 0 &&
                    formik.values.toprice == 0
                ) {
                    setEventList(search_allproducts.results?.[0]?.lotof_new || [])
                }
            } else {
                if (
                    search_allproducts.results.length > 0 &&
                    formik.values.special_events.length == 0 &&
                    formik.values.category.length == 0 &&
                    formik.values.quality_rating.length == 0 &&
                    formik.values.toprice == 0 &&
                    (auctionTitle == 'Flash Deals' ||
                        auctionTitle == 'Todays Top Deals' ||
                        auctionTitle == 'Recently Listed' ||
                        auctionTitle == 'Deals Ending Soon' ||
                        auctionTitle == 'Buy Now')
                ) {
                    if (search_allproducts.results?.[0]?.category_ids.length == 0) setCatList([])
                    if (search_allproducts.results?.[0]?.auctionnotes_new.length == 0)
                        setConditionList([])
                    if (search_allproducts.results?.[0]?.lotof_new.length == 0) setEventList([])
                    if (
                        search_allproducts.results?.[0]?.max_price == null &&
                        search_allproducts.results?.[0]?.min_price == null
                    ) {
                        setMax_price_val(null)
                        setMin_price_val(null)
                    }
                }
                if (formik.values.special_events.length > 0 || formik.values.category.length > 0) {
                    setResetFilter(true)
                }
            }
        }
        setSize(
            get_all_cat?.size?.filter((val) => formik.values.category.includes(val.category_id)),
        )
        setStates(search_allproducts.city)
        // setTimeout(() => {
        //     setLoading(false)
        // }, 1000)
    }, [search_allproducts, formik.values])
    // let buyBestDateTime = []
    // useEffect(() => {
    //     const locationData = JSON.parse(pickupDetails)

    //     const buyBestLocation = locationData[0]?.business_name

    //     const buyBestPickupTimes = locationData[0]?.general
    //     console.log(buyBestPickupTimes, 'location')

    //     buyBestPickupTimes.forEach((item) => {
    //         if (item.Status === 'Open' && item.Day_Times.length > 0) {
    //             item.Day_Times.forEach((timeSlot) => {
    //                 buyBestDateTime.push({
    //                     day: item.Day,
    //                     start_time: timeSlot.start_time,
    //                     end_time: timeSlot.end_time,
    //                 })
    //             })
    //         }
    //     })
    // }, [pickupDetails])
    useEffect(() => {
        setViewProduct([])
        return () => {
            setViewProduct([])
        }
    }, [])

    useEffect(() => {
        if (resetFilter) {
            formik.setValues({
                ...formik.values,
                quality_rating: [],
                toprice: 0,
                category:
                    formik.values.special_events.length > 0 &&
                    formik.values.quality_rating.length == 0 &&
                    formik.values.toprice == 0
                        ? []
                        : formik.values.category,
            })
            setResetFilter(false)
        }
    }, [resetFilter])

    useEffect(() => {
        if (cat_title && catg && !formik.values.category.includes(catg)) {
            setCatName(null)
            setAuctionTitle(null)
        }
    }, [formik.values.category])

    useEffect(() => {
        if (isAuction == 1 && !formik.values.special_events.includes(lotof)) {
            let currentUrl = new URL(window.location.href)

            if (currentUrl.searchParams.has('lotof')) {
                currentUrl.searchParams.set('lotof', '')
                window.history.replaceState({}, '', currentUrl)
            }
            if (currentUrl.searchParams.has('auction')) {
                currentUrl.searchParams.set('auction', 0)
                window.history.replaceState({}, '', currentUrl)
            }
            if (currentUrl.searchParams.has('title')) {
                currentUrl.searchParams.set('title', '')
                window.history.replaceState({}, '', currentUrl)
            }

            setAuctionTitle(null)
        }
    }, [formik.values.special_events])

    const viewProductRef = useRef(viewProduct)
    const suggestedProductsRef = useRef(suggestedProducts)
    const userRef = useRef(user)

    // Sets product and user refrences on page load
    useEffect(() => {
        viewProductRef.current = viewProduct
        suggestedProductsRef.current = suggestedProducts
        userRef.current = user
    })

    const handler = (message, type) => {
        messageHandler(
            message,
            viewProductRef.current,
            userRef.current,
            setAlert,
            setViewProduct,
            type,
        )
    }

    const handler2 = (message, type) => {
        messageHandler(
            message,
            suggestedProductsRef.current,
            userRef.current,
            setAlert,
            setSuggestedProducts,
            type,
        )
    }

    useEffect(() => {
        socket.on('realclosedupdates', (data) => {
            handler(data, 'realclosedupdates')
        })
        socket.on('bidAddtime', (data) => {
            handler(data, 'bidAddtime')
        })

        socket.on('cancelbidemitted', (data) => {
            handler(data, 'cancelbidemitted')
        })

        socket.on('watchlist', (data) => {
            handler(data, 'watchlist')
            handler2(data, 'watchlist')
        })
        socket.on('product_view_count', (data) => {
            handler(data, 'product_view_count')
        })

        socketAuction.on('realclosedupdates', (data) => {
            handler(data, 'realclosedupdates')
        })
        socketAuction.on('bidAddtime', (data) => {
            handler(data, 'bidAddtime')
        })

        return () => {
            socket.off('realclosedupdates', (data) => {
                handler(data, 'realclosedupdates')
            })
            socket.off('bidAddtime', (data) => {
                handler(data, 'bidAddtime')
            })

            socket.off('cancelbidemitted', (data) => {
                handler(data, 'cancelbidemitted')
            })

            socket.off('watchlist', (data) => {
                handler(data, 'watchlist')
                handler2(data, 'watchlist')
            })
            socket.off('product_view_count', (data) => {
                handler(data, 'product_view_count')
            })

            socketAuction.off('realclosedupdates', (data) => {
                handler(data, 'realclosedupdates')
            })
            socketAuction.off('bidAddtime', (data) => {
                handler(data, 'bidAddtime')
            })
        }
    }, [])

    const onHandlePage = (event, value) => {
        const params1 = new URLSearchParams(location.search)
        params1.set('page', String(value))
        history.replace({ pathname: location.pathname, search: params1.toString() })

        formik.setFieldValue('page', value)
        // setPage(value)
        // setLoading(true)
        // getAllSearchItems(
        //     {
        //         ...formik.values,
        //         category: formik.values.category,
        //         quality_rating: undefined,
        //         mprice_filter:
        //             formik.values.toprice == 7
        //                 ? formik.values.mprice_filter
        //                 : estimated_arr.filter(
        //                       (val) => parseInt(val.id) == parseInt(formik.values.toprice),
        //                   )[0].value,
        //         rating_multiple_io: global.condition_data
        //             .filter((item) => formik.values.quality_rating.includes(item.id.toString()))
        //             .map((item) => item.condition),
        //         page: value,
        //         filter_checker: 1,
        //     },
        //     'filterValues',
        // )
        // getAllSearchItems(
        //     {
        //         ...formik.values,
        //         quality_rating: undefined,
        //         mprice_filter:
        //             formik.values.toprice == 7
        //                 ? formik.values.mprice_filter
        //                 : estimated_arr.filter(
        //                       (val) => parseInt(val.id) == parseInt(formik.values.toprice),
        //                   )[0].value,
        //         rating_multiple_io: global.condition_data
        //             .filter((item) => formik.values.quality_rating.includes(item.id.toString()))
        //             .map((item) => item.condition),
        //         page: value,
        //     },
        //     'searchPage',
        // )
        // setLoading(false)
    }

    const getAllProduct = async (bool) => {
        // setLoading(true)
        // getAllSearchProducts(formik.values, 'searchPage').then((res) => {
        //     if (res.success === 'yes' && params.get('product'))
        //         getViewProduct({ product_id: Number(params.get('product')) })
        // })
        // setTimeout(() => {
        //     setLoading(false)
        // }, 1000)
    }

    useEffect(() => {
        if (previousState?.current?.special_events.length > formik.values.special_events.length) {
            formik.setFieldValue('category', [])
            formik.setFieldValue('quality_rating', [])
            formik.setFieldValue('toprice', 0)
        }
        if (global?.storeConfigration?.need_buynow_search?.value == 1) {
            if (parseInt(formik.values.from_id) == 0) {
                formik.values.from = ''
            } else if (parseInt(formik.values.from_id) == 1) {
                formik.setFieldValue('from', 'auction_only')
            } else {
                formik.setFieldValue('from', 'buynow')
            }

            params.set('at', formik.values.from_id)

            history.replace({
                pathname: location.pathname,
                search: params.toString(),
            })
        }
        let currentUrl = new URL(window.location.href)

        if (currentUrl.searchParams.has('rat')) {
            currentUrl.searchParams.set('rat', formik.values.quality_rating)
            window.history.replaceState({}, '', currentUrl)
        }
        if (currentUrl.searchParams.has('est')) {
            currentUrl.searchParams.set('est', formik.values.toprice)
            window.history.replaceState({}, '', currentUrl)
        }
        if (currentUrl.searchParams.has('sort')) {
            currentUrl.searchParams.set('sort', formik.values.orderby)
            window.history.replaceState({}, '', currentUrl)
        }
        if (currentUrl.searchParams.has('cat')) {
            currentUrl.searchParams.set('cat', formik.values.category)
            window.history.replaceState({}, '', currentUrl)
        }
        if (currentUrl.searchParams.has('slimit')) {
            currentUrl.searchParams.set('slimit', formik.values.perlimit)
            window.history.replaceState({}, '', currentUrl)
        }

        if (currentUrl.searchParams.has('page')) {
            currentUrl.searchParams.set('page', formik.values.page)
            window.history.replaceState({}, '', currentUrl)
        }

        // setPage(1)
        // formik.setFieldValue('page', 1)
        setChipData((prev) => {
            const filterData = []
            if (formik.values.category.length > 0) {
                filterData.push({
                    name: 'category',
                    value: formik.values.category,
                })
            }
            if (formik.values.toprice > 0) {
                filterData.push({
                    name: 'toprice',
                    value: [formik.values.toprice],
                })
            }
            if (formik.values.delivery.length > 0) {
                filterData.push({
                    name: 'delivery',
                    value: formik.values.delivery,
                })
            }

            if (formik.values.quality_rating.length > 0) {
                filterData.push({
                    name: 'quality_rating',
                    value: formik.values.quality_rating,
                })
            }
            if (formik.values.special_events.length > 0) {
                filterData.push({
                    name: 'special_events',
                    value: formik.values.special_events,
                })
            }
            return filterData
        })
        if (mountedRef.current) {
            let customwhere = ''
            if (
                lotof &&
                (!formik.values.special_events.includes(lotof) ||
                    formik.values.special_events.length > 1)
            ) {
                lotof = null
                setAuctionTitle(null)
                customwhere = params.get('q')
                    ? getWhere('search', params.get('q'), null, 0)
                    : getWhere('search', '')
            } else {
                customwhere = formik.values.customwhere
            }
            getAllSearchItems(
                {
                    ...formik.values,
                    quality_rating: undefined,
                    category: formik.values.category,
                    // formik.values.special_events.length > 0
                    //     ? formik.values.category
                    //     : auctionTitle !== 'Flash Deals' &&
                    //       auctionTitle !== 'Todays Top Deals' &&
                    //       auctionTitle !== 'Recently Listed' &&
                    //       auctionTitle !== 'Deals Ending Soon' &&
                    //       auctionTitle !== 'Buy Now' &&
                    //       cat_name == null
                    //     ? formik.values.category
                    //     : '',
                    mprice_filter:
                        formik.values.toprice == 7
                            ? formik.values.mprice_filter
                            : estimated_arr.filter(
                                  (val) => parseInt(val.id) == parseInt(formik.values.toprice),
                              )[0].value,
                    rating_multiple_io: global.condition_data
                        .filter((item) => formik.values.quality_rating.includes(item.id.toString()))
                        .map((item) => item.condition),
                    dont_show: formik.values.category.some((val) =>
                        formik.values.dont_show?.includes(val),
                    )
                        ? []
                        : global?.storeConfigration?.donot_show_categories?.value
                        ? global.storeConfigration?.donot_show_categories?.value?.split(',')
                        : [],
                    page: formik.values.page,
                    joinsdata: `a.title as auctionTitle, p.title,a.state as auction_state, a.city as auction_city,a.address as auction_address, a.zipcode as auction_zipcode,p.lot_number,p.sku,p.deed_document,p.lotof,p.auctionnotes,p.avatar as avatar_vc,p.content_head1,p.store_id,p.retailer_link,p.conditionunique,p.hasshipping,p.user_id,p.category_id${
                        user?.id
                            ? `,IFNULL(w.id,0) as watchlisted ,0 AS currentUserBidAmount,(select count(f.id) as cbidnot from bids as f where f.project_id = p.id and f.user_id = ${user?.id} and f.declined=0) as cbidnot`
                            : ''
                    }`,
                    joins: user?.id
                        ? `left join watchlists as w on w.project_id=p.id and w.user_id = ${user?.id} and w.is_delete = 0 inner join auctionlot as a on a.id=p.lotof `
                        : ` inner join auctionlot as a on a.id=p.lotof `,
                    customwhere: customwhere,
                    filter_checker: 1,
                },
                'filterValues',
            )
            getAllSearchItems(
                {
                    ...formik.values,
                    quality_rating: undefined,
                    mprice_filter:
                        formik.values.toprice == 7
                            ? formik.values.mprice_filter
                            : estimated_arr.filter(
                                  (val) => parseInt(val.id) == parseInt(formik.values.toprice),
                              )[0].value,
                    rating_multiple_io: global.condition_data
                        .filter((item) => formik.values.quality_rating.includes(item.id.toString()))
                        .map((item) => item.condition),
                    dont_show: formik.values.category.some((val) =>
                        formik.values.dont_show?.includes(val),
                    )
                        ? []
                        : global?.storeConfigration?.donot_show_categories?.value
                        ? global.storeConfigration?.donot_show_categories?.value?.split(',')
                        : [],
                    page: formik.values.page,
                    joinsdata: `a.title as auctionTitle, p.title,a.state as auction_state, a.city as auction_city,a.address as auction_address, a.zipcode as auction_zipcode,p.lot_number,p.sku,p.deed_document,p.lotof,p.auctionnotes,p.avatar as avatar_vc,p.content_head1,p.store_id,p.retailer_link,p.conditionunique,p.hasshipping,p.user_id,p.category_id${
                        user?.id
                            ? `,IFNULL(w.id,0) as watchlisted ,0 AS currentUserBidAmount,(select count(f.id) as cbidnot from bids as f where f.project_id = p.id and f.user_id = ${user?.id} and f.declined=0) as cbidnot`
                            : ''
                    }`,
                    joins: user?.id
                        ? `left join watchlists as w on w.project_id=p.id and w.user_id = ${user?.id} and w.is_delete = 0 inner join auctionlot as a on a.id=p.lotof `
                        : ` inner join auctionlot as a on a.id=p.lotof `,
                    customwhere: customwhere,
                },
                'searchPage',
            )

            setLoading(true)
            // window.scrollTo(0, 0)
        }
        previousState.current = formik.values
    }, [formik.values])

    useEffect(() => {
        if (filterData[0]?.auctionnotes_new && formik.values.quality_rating.length > 0) {
            const allowedValues = filterData[0].auctionnotes_new
            const existingValues = global.condition_data
                .filter((item) => formik.values.quality_rating.includes(item.id.toString()))
                .map((item) => item.condition)

            const filteredValues = existingValues.filter((value) => allowedValues.includes(value))
            const filteredIds = global.condition_data
                .filter((item) => filteredValues.includes(item.condition.toString()))
                .map((item) => item.id.toString())

            if (JSON.stringify(formik.values.quality_rating) !== JSON.stringify(filteredIds)) {
                formik.setFieldValue('quality_rating', filteredIds)
            }
        }
    }, [filterData])

    useEffect(() => {
        if (
            auctionTitle &&
            isAuction != 1 &&
            cat_name == null &&
            (formik.values.special_events.length > 0 ||
                formik.values.category.length > 0 ||
                formik.values.quality_rating.length > 0 ||
                formik.values.toprice !== 0)
        ) {
            handleFilterDeleteAll()
        }
    }, [auctionTitle])

    useEffect(() => {
        if (user?.id) {
            if (global?.storeConfigration?.need_buynow_search?.value == 1) {
                if (parseInt(formik.values.from_id) == 0) {
                    formik.values.from = ''
                } else if (parseInt(formik.values.from_id) == 1) {
                    formik.setFieldValue('from', 'auction_only')
                } else {
                    formik.setFieldValue('from', 'buynow')
                }

                params.set('at', formik.values.from_id)

                history.replace({
                    pathname: location.pathname,
                    search: params.toString(),
                })
            }
            let currentUrl = new URL(window.location.href)

            if (currentUrl.searchParams.has('rat')) {
                currentUrl.searchParams.set('rat', formik.values.quality_rating)
                window.history.replaceState({}, '', currentUrl)
            }
            if (currentUrl.searchParams.has('est')) {
                currentUrl.searchParams.set('est', formik.values.toprice)
                window.history.replaceState({}, '', currentUrl)
            }
            if (currentUrl.searchParams.has('sort')) {
                currentUrl.searchParams.set('sort', formik.values.orderby)
                window.history.replaceState({}, '', currentUrl)
            }
            if (currentUrl.searchParams.has('cat')) {
                currentUrl.searchParams.set('cat', formik.values.category)
                window.history.replaceState({}, '', currentUrl)
            }
            if (currentUrl.searchParams.has('slimit')) {
                currentUrl.searchParams.set('slimit', formik.values.perlimit)
                window.history.replaceState({}, '', currentUrl)
            }

            if (currentUrl.searchParams.has('page') || formik.values.page) {
                currentUrl.searchParams.set('page', 1)
                window.history.replaceState({}, '', currentUrl)
            }

            // setPage(1)

            if (mountedRef.current) {
                getAllSearchItems(
                    {
                        ...formik.values,
                        category: formik.values.category,
                        // formik.values.special_events.length > 0
                        //     ? formik.values.category
                        //     : auctionTitle !== 'Flash Deals' &&
                        //       auctionTitle !== 'Todays Top Deals' &&
                        //       auctionTitle !== 'Recently Listed' &&
                        //       auctionTitle !== 'Deals Ending Soon' &&
                        //       auctionTitle !== 'Buy Now' &&
                        //       cat_name == null
                        //     ? formik.values.category
                        //     : '',
                        quality_rating: undefined,
                        mprice_filter:
                            formik.values.toprice == 7
                                ? formik.values.mprice_filter
                                : estimated_arr.filter(
                                      (val) => parseInt(val.id) == parseInt(formik.values.toprice),
                                  )[0].value,
                        rating_multiple_io: global.condition_data
                            .filter((item) =>
                                formik.values.quality_rating.includes(item.id.toString()),
                            )
                            .map((item) => item.condition),
                        dont_show: formik.values.category.some((val) =>
                            formik.values.dont_show?.includes(val),
                        )
                            ? []
                            : global?.storeConfigration?.donot_show_categories?.value
                            ? global.storeConfigration?.donot_show_categories?.value?.split(',')
                            : [],
                        page: formik.values.page,
                        joinsdata: `a.title as auctionTitle, p.title,a.state as auction_state, a.city as auction_city,a.address as auction_address, a.zipcode as auction_zipcode,p.lot_number,p.sku,p.deed_document,p.lotof,p.auctionnotes,p.avatar as avatar_vc,p.content_head1,p.store_id,p.retailer_link,p.conditionunique,p.hasshipping,p.user_id,p.category_id${
                            user?.id
                                ? `,IFNULL(w.id,0) as watchlisted ,0 AS currentUserBidAmount,(select count(f.id) as cbidnot from bids as f where f.project_id = p.id and f.user_id = ${user?.id} and f.declined=0) as cbidnot`
                                : ''
                        }`,
                        joins: user?.id
                            ? `left join watchlists as w on w.project_id=p.id and w.user_id = ${user?.id} and w.is_delete = 0 inner join auctionlot as a on a.id=p.lotof `
                            : ` inner join auctionlot as a on a.id=p.lotof `,
                        filter_checker: 1,
                    },
                    'filterValues',
                )
                getAllSearchItems(
                    {
                        ...formik.values,
                        quality_rating: undefined,
                        mprice_filter:
                            formik.values.toprice == 7
                                ? formik.values.mprice_filter
                                : estimated_arr.filter(
                                      (val) => parseInt(val.id) == parseInt(formik.values.toprice),
                                  )[0].value,
                        rating_multiple_io: global.condition_data
                            .filter((item) =>
                                formik.values.quality_rating.includes(item.id.toString()),
                            )
                            .map((item) => item.condition),
                        dont_show: formik.values.category.some((val) =>
                            formik.values.dont_show?.includes(val),
                        )
                            ? []
                            : global?.storeConfigration?.donot_show_categories?.value
                            ? global.storeConfigration?.donot_show_categories?.value?.split(',')
                            : [],
                        page: formik.values.page,
                        joinsdata: `a.title as auctionTitle, p.title,a.state as auction_state, a.city as auction_city,a.address as auction_address, a.zipcode as auction_zipcode,p.lot_number,p.sku,p.deed_document,p.lotof,p.auctionnotes,p.avatar as avatar_vc,p.content_head1,p.store_id,p.retailer_link,p.conditionunique,p.hasshipping,p.user_id,p.category_id${
                            user?.id
                                ? `,IFNULL(w.id,0) as watchlisted ,0 AS currentUserBidAmount,(select count(f.id) as cbidnot from bids as f where f.project_id = p.id and f.user_id = ${user?.id} and f.declined=0) as cbidnot`
                                : ''
                        }`,
                        joins: user?.id
                            ? `left join watchlists as w on w.project_id=p.id and w.user_id = ${user?.id} and w.is_delete = 0 inner join auctionlot as a on a.id=p.lotof `
                            : ` inner join auctionlot as a on a.id=p.lotof `,
                    },
                    'searchPage',
                )
            }
            getAllSearchItems(
                {
                    ...suggestedItemSearch,
                    page: 1,
                    joinsdata: `a.title as auctionTitle, p.title,a.state as auction_state, a.city as auction_city,a.address as auction_address, a.zipcode as auction_zipcode,p.lot_number,p.sku,p.deed_document,p.lotof,p.auctionnotes,p.avatar as avatar_vc,p.content_head1,p.store_id,p.retailer_link,p.conditionunique,p.hasshipping,p.user_id,p.category_id${
                        user?.id
                            ? `,IFNULL(w.id,0) as watchlisted ,0 AS currentUserBidAmount,(select count(f.id) as cbidnot from bids as f where f.project_id = p.id and f.user_id = ${user?.id} and f.declined=0) as cbidnot`
                            : ''
                    }`,
                    joins: user?.id
                        ? `left join watchlists as w on w.project_id=p.id and w.user_id = ${user?.id} and w.is_delete = 0 inner join auctionlot as a on a.id=p.lotof `
                        : ` inner join auctionlot as a on a.id=p.lotof `,
                },
                'suggestedItems',
            )
            setLoading(true)
        }
    }, [user?.id])

    useEffect(() => {
        const params = new URLSearchParams(window.location.search.substring(1))
        const catValue = params.get('cat')
        formik.setFieldValue(
            'category',
            catValue && catValue.trim() !== '' ? catValue.split(',') : [],
        )
        formik.setFieldValue(
            'customwhere',
            params.get('q') ? getWhere('search', params.get('q')) : getWhere('search', ''),
        )
        formik.setFieldValue(
            'from_id',
            params.get('q') && params.get('at')
                ? params.get('at')
                : params.get('q')
                ? 0
                : params.get('at')
                ? params.get('at')
                : 1,
        )
        mountedRef.current = true
    }, [])

    useEffect(() => {
        const params = new URLSearchParams(window.location.search.substring(1))
        const qValue = params.get('q')
        let catValue = params.get('cat')
        setSearchValue(qValue)
        const orderbyValue =
            params.get('sort') ||
            (location.pathname.includes('/todays-top-deals')
                ? '1'
                : location.pathname.includes('/recently-listed')
                ? '2'
                : location.pathname.includes('/deals-ending-soon')
                ? '7'
                : location.pathname.includes('/buynow')
                ? '01'
                : cat_title
                ? '6'
                : '')

        let title =
            params.get('title') ||
            (location.pathname.includes('/todays-top-deals')
                ? 'Todays Top Deals'
                : location.pathname.includes('/recently-listed')
                ? 'Recently Listed'
                : location.pathname.includes('/deals-ending-soon')
                ? 'Deals Ending Soon'
                : location.pathname.includes('/buynow')
                ? 'Buy Now'
                : null)

        if (cat_title && global.searchCategories?.length > 0) {
            const cat_title_clean = cat_title.replace(/[^a-zA-Z0-9]/g, '').toLowerCase()
            const cat_obj = global.searchCategories.find(
                (c) => c.description.replace(/[^a-zA-Z0-9]/g, '').toLowerCase() === cat_title_clean,
            )

            if (cat_obj) {
                setCatg(cat_obj.id.toString())
                catValue = cat_obj.id.toString()
                setCatName(cat_obj.description)
                title = cat_obj.description
            }
        }

        const category = catValue && catValue.trim() !== '' ? catValue.split(',') : []
        setCatVal(category)

        const areArraysEqual = (arr1, arr2) => {
            if (arr1.length !== arr2.length) return false
            for (let i = 0; i < arr1.length; i++) {
                if (arr1[i] !== arr2[i]) return false
            }
            return true
        }

        if (!areArraysEqual(formik.values.category, category)) {
            formik.setFieldValue('category', category)
        }

        const customwhere =
            qValue !== ''
                ? getWhere('search', qValue, orderbyValue)
                : getWhere('search', '', orderbyValue)

        if (formik.values.orderby !== orderbyValue) {
            formik.setFieldValue('orderby', orderbyValue)
        }

        if (formik.values.customwhere !== customwhere) {
            formik.setFieldValue('customwhere', customwhere)
        }

        setAuctionTitle(title)
    }, [window.location.search, location.pathname, cat_title])

    const toggleDrawer = (anchor, open, data) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return
        }
        if (open) {
            setState({ ...state, [anchor]: open, data: data })
        } else {
            setState({ ...state, [anchor]: open, data: {} })
        }
    }

    const pageOptions = [
        {
            value: '50',
            show: 'Results 50 per page',
        },
        {
            value: '75',
            show: 'Results 75 per page',
        },
        {
            value: '100',
            show: 'Results 100 per page',
        },
    ]

    const sortShow = [
        {
            value: '',
            show: 'None',
        },
        {
            value: 3,
            show: 'Current price low to high',
        },
        {
            value: 11,
            show: 'Current price high to low',
        },
        {
            value: 6,
            show: 'Time remaining',
        },
        {
            value: 2,
            show: 'Recently listed',
        },
    ]

    const sortShow2 = [
        {
            value: 6,
            show: 'Latest online',
        },
        {
            value: 16,
            show: 'Bid amount low to high',
        },
        {
            value: 17,
            show: 'Bid amount high to low',
        },
        {
            value: 18,
            show: 'Retail value low to high',
        },
        {
            value: 19,
            show: 'Retail value high to low',
        },
    ]

    const NextArrow = ({ className, style, onClick, set5Next }) => {
        return (
            <div
                className={className}
                style={{
                    ...style,
                    right: isMobile ? (set5Next ? '5px' : '35px') : -25,
                    top: isMobile ? (set5Next ? '125px' : '90px') : 70,
                    display: 'block',
                    zIndex: 999,
                }}
                onClick={onClick}
            >
                <span className="material-icons-outlined" size="14">
                    arrow_circle_left
                </span>
            </div>
        )
    }

    const PrevArrow = ({ className, style, onClick, set5Prev }) => {
        return (
            <div
                className={className}
                style={{
                    ...style,
                    left: isMobile ? (set5Prev ? '-15px' : '15px') : -50,
                    top: isMobile ? (set5Prev ? '125px' : '90px') : 70,
                    display: 'block',
                    zIndex: 999,
                }}
                onClick={onClick}
            >
                <span className="material-icons-outlined" size="14">
                    navigate_left
                </span>
            </div>
        )
    }

    const settings4 = {
        dots: false,
        fade: false,
        arrows: true,
        infinite: false,
        slidesToShow: 6,
        centerMode: false,
        slidesToScroll: 1,
        autoplay: false,
        speed: 1000,
        nav: false,
        autoplaySpeed: 4000,
        cssEase: 'linear',
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 6,
                },
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    }

    const settings5 = {
        dots: false,
        fade: false,
        arrows: true,
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: false,
        speed: 1000,
        nav: false,
        centerMode: false,
        variableWidth: false,
        autoplaySpeed: 4000,
        cssEase: 'linear',
        // nextArrow: <NextArrow set5Next={'set5Next'} />,
        // prevArrow: <PrevArrow set5Prev={'set5Prev'} />,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 4,
                },
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    }

    const findFilterLabel = (data) => {
        if (data.name == 'category') {
            return searchCategories2.filter((item) => item.id == data.value)[0]?.name
        }
        if (data.name == 'toprice') {
            return data.value == 7
                ? `$${formik.values.mprice_filter[0]} - $${formik.values.mprice_filter[1]}`
                : estimated_arr.filter((item) => item.id == data.value)[0]?.description
        }
        if (data.name == 'delivery') {
            return delivery_options.filter((item) => item.value == data.value)[0]?.description
        }
        if (data.name == 'quality_rating') {
            return global.condition_data
                .filter((item) => data.value.includes(item.id.toString()))
                .map((item) => item.condition)[0]
        }
        if (data.name == 'special_events') {
            return special_event_options.filter((item) => item.id == data.value)[0]?.description
        }
    }

    const handleFilterDelete = (data) => {
        if (data.name == 'category') {
            const catVal = formik.values.category.filter((item) => item != data.value)
            return formik.setFieldValue('category', catVal)
        }
        if (data.name == 'toprice') {
            return formik.setFieldValue('toprice', 0)
        }
        if (data.name == 'delivery') {
            const deliveryVal = formik.values.delivery.filter((item) => item != data.value)
            return formik.setFieldValue('delivery', deliveryVal)
        }
        if (data.name == 'quality_rating') {
            const ratingVal = formik.values.quality_rating.filter((item) => item != data.value)
            return formik.setFieldValue('quality_rating', ratingVal)
        }
        if (data.name == 'special_events') {
            const spcVal = formik.values.special_events.filter((item) => item != data.value)
            return formik.setFieldValue('special_events', spcVal)
        }
    }

    const handleFilterDeleteAll = () => {
        if (cat_val.length > 0 || (searchbarValue !== null && searchbarValue !== '')) {
            handleRedirectInternal(history, 'search?q=&cat=&est=0&rat=&view=&sort=17&slimit=50')
            formik.setFieldValue('category', [])
        } else {
            formik.setFieldValue('category', [])
        }

        formik.setFieldValue('toprice', 0)
        formik.setFieldValue('delivery', [])
        formik.setFieldValue('quality_rating', [])
        formik.setFieldValue('special_events', [])
        if (
            auctionTitle !== 'Flash Deals' &&
            auctionTitle !== 'Todays Top Deals' &&
            auctionTitle !== 'Recently Listed' &&
            auctionTitle !== 'Deals Ending Soon' &&
            auctionTitle !== 'Buy Now'
        ) {
            formik.setFieldValue('orderby', 17)
        }
        // handleRedirectInternal(history, 'search?q=&cat=&est=0&rat=&view=&sort=17&slimit=50')
    }

    return (
        <>
            <SEOTAG
                page={
                    location.pathname.includes('/todays-top-deals')
                        ? 'Todays Top Deals'
                        : location.pathname.includes('/recently-listed')
                        ? 'Recently Listed'
                        : location.pathname.includes('/deals-ending-soon')
                        ? 'Deals Ending Soon'
                        : location.pathname.includes('/buynow')
                        ? 'Buy Now'
                        : cat_name
                        ? cat_name
                        : 'Search'
                }
            />
            <Layout props={props}>
                <UserActivity page="lot_search" />
                <div className="customContainer position-relative mt-4">
                    <div className="searchContainer">
                        <div className="searchLt">
                            <FilterPanel
                                formik={formik}
                                filterValues={filterValues}
                                clearAll={handleFilterDeleteAll}
                            />
                        </div>
                        <div className="searchRt">
                            <div className="searchMiscAct searchTitleFilter d-flex justify-content-start flex-wrap my-3">
                                {isVarifiedGfTheme && (
                                    <>
                                        {auctionTitle !== null ? (
                                            <h4 className="auctionTitle">
                                                {auctionTitle == 'Flash Deals' ||
                                                auctionTitle == 'Todays Top Deals' ||
                                                auctionTitle == 'Recently Listed' ||
                                                auctionTitle == 'Deals Ending Soon' ||
                                                auctionTitle == 'Buy Now'
                                                    ? `Deals -- ${auctionTitle}`
                                                    : cat_name
                                                    ? `Category -- ${cat_name}`
                                                    : `Auctions -- ${auctionTitle}`}{' '}
                                            </h4>
                                        ) : (
                                            <>
                                                <h4 className="auctionTitle">
                                                    Location -- {handleLocations}
                                                </h4>
                                            </>
                                        )}
                                    </>
                                )}
                                {/* <div className="favWonBox">
                                    <div className="pickHrs">
                                        <>
                                            <h4 className="tit">
                                                {location}
                                                Pickup Hours
                                            </h4>
                                            <ol className="unorlst">
                                                {buyBestDateTime.map((item) => (
                                                    <>
                                                        {item.Day_Times.length && (
                                                            <li>
                                                                {item.Day}: {item.start_time} -
                                                                {item.end_time}
                                                            </li>
                                                        )}
                                                    </>
                                                ))}
                                            </ol>
                                        </>
                                        <h5 className="pickupinfo">
                                            {isBuyBestProject ? 'Fredericksburg' : 'Columbus'}{' '}
                                            Pickup Location<br></br>
                                            <a
                                                href="#"
                                                className="mt-2 d-block"
                                                onClick={(e) => {
                                                    e.preventDefault()
                                                    handleRedirectInternal(history, 'locations')
                                                }}
                                            >
                                                {isBuyBestProject
                                                    ? '18 Blackjack Road, Suite 101, Fredericksburg, VA, 22405'
                                                    : '4645 Morse Centre Rd. Columbus, OH 43229'}
                                            </a>
                                        </h5>
                                    </div>
                                    <div className="mapLoc">
                                        <iframe
                                            src={`${
                                                isBuyBestProject
                                                    ? 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3097.506950494901!2d-77.4455092!3d38.3862645!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89b6e9371ff8defd%3A0xe13ef7d4795a4ed5!2s18%20Blackjack%20Rd%2C%20Fredericksburg%2C%20VA%2022405!5e0!3m2!1sen!2sus!4v1753708800000!5m2!1sen!2sus'
                                                    : 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d763.3960855282165!2d-82.96443800000002!3d40.062376!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88388bc7e5a608f1%3A0x989c19f27cf7c1a!2sRetail%20Rush!5e0!3m2!1sen!2sus!4v1753705578924!5m2!1sen!2sus'
                                            }`}
                                            width="254"
                                            height="126"
                                            style={{ border: 0 }}
                                            allowFullScreen=""
                                            loading="lazy"
                                            referrerPolicy="no-referrer-when-downgrade"
                                        ></iframe>
                                    </div>
                                </div> */}
                                {pickupDateStaticEnabled ? (
                                    <div style={{ 'margin-top': '20px' }}>
                                        <p>
                                            <b>Pick Up Date & Time:</b> {pickupDateStaticText}
                                        </p>
                                    </div>
                                ) : (
                                    ''
                                )}
                                <div className="breadCrums">
                                    {chipData.length > 0 ? (
                                        <Paper component="ul" className={classes.root}>
                                            {chipData.map((data) =>
                                                data.value.map((val) => (
                                                    <li key={`${data.name}-${val}`}>
                                                        <Chip
                                                            label={findFilterLabel({
                                                                ...data,
                                                                value: val,
                                                            })}
                                                            size="medium"
                                                            className={classes.chip}
                                                            onDelete={() => {
                                                                handleFilterDelete({
                                                                    ...data,
                                                                    value: val,
                                                                })
                                                            }}
                                                            deleteIcon={<CancelOutlinedIcon />}
                                                        />
                                                    </li>
                                                )),
                                            )}
                                        </Paper>
                                    ) : null}
                                </div>
                            </div>
                            <div className="asdasd searchMiscAct d-flex justify-content-end flex-wrap my-3">
                                {isVarifiedGfTheme && (
                                    <div className="mt-3 d-flex justify-content-end flex-wrap">
                                        {!isVarifiedGfTheme ? (
                                            <div className="gridListToggle">
                                                <Button
                                                    className={
                                                        auctionView != 'list' ? 'active' : ''
                                                    }
                                                    onClick={() => setAuctionView('grid')}
                                                >
                                                    <img
                                                        src="/lots-images/loa-grid-icon.svg"
                                                        alt=""
                                                    />
                                                </Button>
                                                <Button
                                                    className={
                                                        auctionView === 'list' ? 'active' : ''
                                                    }
                                                    onClick={() => setAuctionView('list')}
                                                >
                                                    <img
                                                        src="/lots-images/loa-list-icon.svg"
                                                        alt=""
                                                    />
                                                </Button>
                                            </div>
                                        ) : (
                                            ''
                                        )}
                                        {search_allproducts &&
                                            !!totalViewProduct &&
                                            totalViewProduct > formik.values.perlimit &&
                                            !isLoading && (
                                                <Pagination
                                                    className="custom designPagination"
                                                    count={Math.ceil(
                                                        totalViewProduct / formik.values.perlimit,
                                                    )}
                                                    totalProductCount={totalViewProduct}
                                                    currentPage={formik.values.page}
                                                    page={parseInt(formik.values.page)}
                                                    variant="text"
                                                    onChange={onHandlePage}
                                                />
                                            )}
                                        <div className="auctionSearchSelectBox">
                                            <CustomSelect
                                                label="Results per page"
                                                name="resultsPerPage"
                                                selectType="noBorder"
                                                value={formik.values.perlimit}
                                                size="small"
                                                onChange={(event, editor) => {
                                                    formik.setFieldValue(
                                                        'perlimit',
                                                        event.target.value,
                                                    )
                                                }}
                                            >
                                                {pageOptions.map((opt, optindex) => (
                                                    <option value={opt.value}>{opt.show}</option>
                                                ))}
                                            </CustomSelect>
                                            <CustomSelect
                                                label="Sort by"
                                                value={formik.values.orderby}
                                                size="small"
                                                selectType="noBorder"
                                                name="order_by"
                                                // shrink={search.orderby !== '' ? true : false}
                                                onChange={(event, editor) => {
                                                    formik.setFieldValue(
                                                        'order_by',
                                                        getOrderBy(event.target.value),
                                                    )

                                                    formik.setFieldValue(
                                                        'orderby',
                                                        event.target.value,
                                                    )
                                                }}
                                            >
                                                {isVarifiedGfTheme
                                                    ? sortShow2
                                                          .filter((opt) =>
                                                              auctionTitle == 'Buy Now'
                                                                  ? opt.value !== 16 &&
                                                                    opt.value !== 17
                                                                      ? true
                                                                      : false
                                                                  : true,
                                                          )
                                                          .map((opt, optindex) => (
                                                              <option value={opt.value}>
                                                                  {opt.show}
                                                              </option>
                                                          ))
                                                    : sortShow.map((opt, optindex) => (
                                                          <option value={opt.value}>
                                                              {opt.show}
                                                          </option>
                                                      ))}
                                            </CustomSelect>
                                        </div>
                                    </div>
                                )}
                                <Button
                                    className="toggleRespDrawer mt-3"
                                    variant="outlined"
                                    onClick={toggleDrawer('bottom', true)}
                                >
                                    <span className="material-icons">tune</span>
                                    Filters
                                </Button>
                            </div>

                            {isLoading ? (
                                <div>
                                    <Loaders
                                        name="product_grid_view"
                                        isLoading={isLoading}
                                        loop={6}
                                    />
                                </div>
                            ) : viewProduct.length > 0 ? (
                                <SearchProductList
                                    listview={auctionView == 'list'}
                                    searchResult={viewProduct}
                                    setViewProduct={setViewProduct}
                                    className="liquidationBuyCard"
                                    getAllProducts={getAllProduct}
                                    cardType={auctionView}
                                    audio={audio}
                                    enableZoomOnHover={true}
                                    at={formik.values.from_id}
                                    card_theme="lotsauction"
                                    noBuyNow={true}
                                />
                            ) : (
                                <NoRecordsFound />
                            )}
                            {search_allproducts &&
                                !!totalViewProduct &&
                                totalViewProduct > formik.values.perlimit &&
                                !isLoading && (
                                    <Pagination
                                        count={Math.ceil(totalViewProduct / formik.values.perlimit)}
                                        totalProductCount={totalViewProduct}
                                        currentPage={formik.values.page}
                                        page={parseInt(formik.values.page)}
                                        onChange={onHandlePage}
                                    />
                                )}
                        </div>
                    </div>
                </div>
                {isVarifiedGfTheme && !isBargainsProject && (
                    <>
                        <div className="why-choose">
                            <div className="customContainer">
                                <div className="googleReviewPoint mt-4">
                                    <div className="customContainer pb-4">
                                        {isVarifiedGfTheme ? <Reviews /> : <Reviews />}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="searchSuugerItems">
                            <div className="customContainer">
                                <div className="searchSuugerItemsBox">
                                    <div className="">
                                        <h4 className="title">Suggested Items </h4>
                                        {suggestedProducts.length > 0 ? (
                                            <Slider {...settings5}>
                                                {suggestedProducts.map((item, index) => (
                                                    <div key={index} className="px-2">
                                                        <LotProduct
                                                            data={item}
                                                            lotImages={item.lotImages}
                                                            link={`/gallery/product-view/${item.id}`}
                                                            handleClick={() =>
                                                                handleRedirectInternal(
                                                                    history,
                                                                    `product/${id}?cat=`,
                                                                )
                                                            }
                                                            timerTheme={props.timerTheme}
                                                            type={props.type ? props.type : ''}
                                                            cardTheme={props.cardTheme}
                                                            card_theme="lotsauction"
                                                            noBuyNow={true}
                                                            noTimer={props.noTimer}
                                                            getAllProducts={getAllSearchProducts}
                                                            setViewProduct={setSuggestedProducts}
                                                            viewProduct={suggestedProducts}
                                                            audio={props.audio}
                                                            productViewLink={`/product/${item.id}?cat=`}
                                                            bidStatus="true"
                                                            timerIcon={true}
                                                            searchCard={true}
                                                            hideQuickBid={
                                                                props.hideQuickBid
                                                                    ? props.hideQuickBid
                                                                    : false
                                                            }
                                                        />
                                                    </div>
                                                ))}
                                            </Slider>
                                        ) : (
                                            <div className="card card-body text-center">
                                                No items Found!
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        {!isBuyBestProject && (
                            <div className="why-choose searchlayout">
                                <div className="customContainer">
                                    <div className="googleReviewPoint mt-4 recent">
                                        <div className="">
                                            <h4 className="title">Recently Viewed</h4>
                                            {recentlyViewedProducts.length > 0 ? (
                                                <Slider {...settings4}>
                                                    {recentlyViewedProducts.map((data, index) => (
                                                        <div key={index} className="recenlyCard">
                                                            <img
                                                                src={`${process.env.REACT_APP_PRODUCT_IMAGE_URL}${data.avatar_vc}`}
                                                                alt="view Images"
                                                                width={100}
                                                                height={100}
                                                                onClick={() =>
                                                                    handleRedirectInternal(
                                                                        history,
                                                                        `product/${data.id}?cat=`,
                                                                    )
                                                                }
                                                                onError={(e) => {
                                                                    e.target.onerror = null // prevents infinite loop if error.png fails
                                                                    e.target.src =
                                                                        '/lots-images/greenField/errorplaceholer.jpg'
                                                                }}
                                                            />
                                                        </div>
                                                    ))}
                                                </Slider>
                                            ) : (
                                                <div className="card card-body text-center">
                                                    No items Found!
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </>
                )}
                <Drawer
                    anchor="bottom"
                    open={state['bottom']}
                    className="responsiveFilterDrawer"
                    onClose={toggleDrawer('bottom', false)}
                    onOpen={toggleDrawer('bottom', true)}
                >
                    <div
                        className={clsx(classes.list, 'bottom')}
                        role="presentation"
                        // onClick={toggleDrawer('bottom', false)}
                        onKeyDown={toggleDrawer('bottom', false)}
                    >
                        <FilterPanel
                            formik={formik}
                            filterValues={filterValues}
                            clearAll={handleFilterDeleteAll}
                            closeToggle={toggleDrawer('bottom', false)}
                        />
                    </div>
                </Drawer>
            </Layout>
        </>
    )
}

export default AuctionSearchComponent
